import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DailyReviewComponent } from './daily-review.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSelectModule } from 'ngx-select-ex';
import { CashPaymentsComponent } from './cash-payments/cash-payments.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { AppSharedModule } from 'dm-src/app/modules/shared/app-shared.module';
import { SharedModule } from 'shared';

@NgModule({
    declarations: [DailyReviewComponent, CashPaymentsComponent],
    imports: [
        CommonModule,
        TranslateModule,
        NgxSelectModule,
        NgbNavModule,
        AppSharedModule,
        SharedModule,
    ],
})
export class DailyReviewModule {}
